import styles from './CatalogTagFilter.module.css';

export function CatalogTagFilter({ tags = [], selectedIds = [], loading = false, onToggle }) {
  if (loading && tags.length === 0) {
    return (
      <div className={styles.list} aria-busy="true">
        <span className={styles.skeleton} />
        <span className={styles.skeleton} />
      </div>
    );
  }

  if (!tags.length) {
    return <p className={styles.empty}>Теги пока недоступны</p>;
  }

  const selected = new Set(selectedIds.map(String));

  return (
    <div className={styles.list} role="group" aria-label="Фильтр по тегам">
      {tags.map((tag) => {
        const active = selected.has(String(tag.id));
        return (
          <button
            key={tag.id}
            type="button"
            className={`${styles.chip} ${active ? styles.chipActive : ''}`}
            style={
              active
                ? {
                    backgroundColor: tag.color || 'var(--color-primary)',
                    borderColor: tag.color || 'var(--color-primary)',
                  }
                : undefined
            }
            aria-pressed={active}
            onClick={() => onToggle(tag.id)}
          >
            <span
              className={styles.dot}
              style={{ backgroundColor: tag.color || 'var(--color-primary)' }}
              aria-hidden="true"
            />
            {tag.name}
          </button>
        );
      })}
    </div>
  );
}
